import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';
import api from '../services/api';

const META = {
  sed: {
    subtitle: 'B-BBEE Scorecard — Socio-Economic Development Element',
    scorecardPath: '/sed/scorecard',
    submitPath: '/sed/submit-datasheet',
  },
  sed_transport: {
    subtitle: 'B-BBEE Scorecard — Socio-Economic Development Element (Transport Road Freight)',
    scorecardPath: '/sed/scorecard/sed-transport',
    submitPath: '/sed/submit-datasheet/sed-transport',
  },
};

const SED_GROUP_KEYS = new Set(['sed', 'sed_transport']);

const SocioEconomicDevelopment = () => {
  const navigate = useNavigate();
  const { elementKey: rawElementKey } = useParams();
  const elementKey = (rawElementKey || 'sed').replace(/-/g, '_');
  const meta = META[elementKey] || META.sed;

  const [title, setTitle] = useState('Socio-Economic Development');

  useEffect(() => {
    api.get('/core/scorecard/list_elements/')
      .then(res => {
        const group = res.data.find(g => SED_GROUP_KEYS.has(g.key));
        if (group?.label) setTitle(group.label);
      })
      .catch(() => {});
  }, []);

  const actions = [
  {
    label: 'Beneficiaries',
    onClick: () => navigate(`/socio-economic-development/documentation/${elementKey}`),
    desc: 'SED beneficiary management and records',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    label: 'Contributions',
    desc: 'Monetary and non-monetary contributions',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
  },
  {
    label: 'Socio-Economic Development Scorecard',
    onClick: () => navigate(meta.scorecardPath),
    desc: 'Socio-Economic Development scorecard data and compliance tracking',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
        <rect x="9" y="3" width="6" height="4" rx="1"/>
        <line x1="9" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="16" x2="13" y2="16"/>
      </svg>
    ),
  },
  {
    label: 'Projects',
    desc: 'Active SED community projects',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
        <line x1="12" y1="17" x2="12" y2="21"/>
      </svg>
    ),
  },
  {
    label: 'Community Spend',
    desc: 'Community development expenditure',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
  },
  {
    label: 'Reports',
    onClick: () => navigate('/reports/socio-economic-development'),
    desc: 'SED impact and compliance reports',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
  },
  {
    label: 'Submit Data',
    onClick: () => navigate(meta.submitPath),
    desc: 'Enter and submit scorecard data',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="22" y1="2" x2="11" y2="13"/>
        <polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    ),
  },
  ];

  return (
    <DashboardPage
      theme={elementKey}
      title={title}
      subtitle={meta.subtitle}
      actions={actions}
    />
  );
};

export default SocioEconomicDevelopment;
